// extracted by mini-css-extract-plugin
export var icon = "_45-1";
export var subtext = "_45-0";